import React from "react";
import { Thermometer, Zap, Package, ShieldCheck, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function YourGoExperience() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = [{
    icon: <Thermometer className="w-6 h-6" />,
    title: "שמירת חום מקסימלית",
    description: "טכנולוגיית בידוד מתקדמת המבטיחה שהבשר יגיע אליכם חם ועסיסי, בדיוק כפי שיצא מהמעשנה."
  }, {
    icon: <Zap className="w-6 h-6" />,
    title: "שירות מהיר במיוחד",
    description: "בין אם זה לארוחת צהריים או לאירוע, תצאו מכאן ישר לאכול בלי לחכות"
  }, {
    icon: <Package className="w-6 h-6" />,
    title: "אריזת פרימיום חכמה",
    description: "עיצוב ארגונומי ואסתטי ששומר על שלמות המנה ומונע דליפות, לחוויית אכילה נקייה ויוקרתית."
  }, {
    icon: <ShieldCheck className="w-6 h-6" />,
    title: "טריות מובטחת",
    description: "חומרי האריזה שלנו נבחרו בקפידה כדי לשמר את הטעמים העמוקים והמרקם הייחודי של הבשר."
  }];
  return <section id="חוויית-ה-go-שלכם" ref={ref} className={`dark bg-muted text-foreground py-20 lg:py-28 overflow-hidden transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {}
          <div className="flex flex-col space-y-10 order-2 lg:order-1">
            <div className="space-y-4">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white">מערך <span className="text-primary">העשן וקח</span> שלנו</h2>
              <p className="text-lg text-muted-foreground max-w-xl leading-relaxed"><br /></p>
            </div>

            <div className="grid grid-cols-1 gap-8">
              {features.map((feature, i) => <div key={i} data-index={i} className="flex items-start gap-4 group">
                  <div className="shrink-0 mt-1 p-3 rounded-lg bg-background/50 border border-border shadow-sm transition-colors group-hover:border-chart-5/50">
                    {}
                    <div className="text-chart-5">
                      {feature.icon}
                    </div>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2 text-foreground group-hover:text-primary transition-colors duration-300">
                      {feature.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>)}
            </div>

            <div className="pt-4">
              <Button asChild size="lg" className="text-base px-8 h-12">
                <Link to="/SmokedMenuPage">
                  הזמינו עכשיו
                  <ArrowLeft className="mr-2 w-5 h-5" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative order-1 lg:order-2 h-full min-h-[400px] lg:min-h-[600px] w-full">
            <div className="absolute inset-0 bg-gradient-to-tr from-background/20 to-transparent z-10 rounded-2xl pointer-events-none" />
            <div className="relative h-full w-full rounded-2xl overflow-hidden shadow-2xl border border-border/50 group">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557505/img/smoke_and_go_packaging_lifestyle.png" alt="אריזת פרימיום של SMOKE & GO" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              
              {}
              <div className="absolute bottom-6 right-6 z-20 bg-background/95 backdrop-blur-md border border-border p-4 rounded-xl shadow-lg max-w-[200px]">
                <p className="text-sm font-bold text-primary mb-1">SMOKE & GO</p>
                <p className="text-xs text-muted-foreground">
                  אריזות שומרות חום לטעם מושלם בכל מקום.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}